import { render, staticRenderFns } from "./TenantGuidelinesDetailForm.vue?vue&type=template&id=6aa53532&scoped=true"
import script from "./TenantGuidelinesDetailForm.vue?vue&type=script&lang=js"
export * from "./TenantGuidelinesDetailForm.vue?vue&type=script&lang=js"
import style0 from "./TenantGuidelinesDetailForm.vue?vue&type=style&index=0&id=6aa53532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa53532",
  null
  
)

export default component.exports